import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import * as PropTypes from 'prop-types';
import { cloneLoop } from '@utiljs/clone';
import ClickOutside from 'react-click-outside';
import Icon from '../Icon';
import { isFunction } from '@utiljs/is';
import Link from '../_utils/Link';

var Cascader = /*#__PURE__*/function (_React$Component) {
  _inherits(Cascader, _React$Component);

  var _super = _createSuper(Cascader);

  function Cascader(props) {
    var _this;

    _classCallCheck(this, Cascader);

    _this = _super.call(this, props); // 初始化选择值以及选择项

    _this.init = function (options, value) {
      var selectedOptions = [];
      var optionArr = cloneLoop(options);
      value.map(function (valueItem) {
        if (optionArr) {
          var result = optionArr.filter(function (optionsItem) {
            return optionsItem[_this.names.value] === valueItem;
          });

          if (result.length !== 0) {
            selectedOptions.push(result[0]);
            optionArr = result[0][_this.names.children];
          }
        }
      });
      return {
        value: value,
        tempValue: cloneLoop(value),
        selectedOptions: selectedOptions,
        tempSelectedOptions: cloneLoop(selectedOptions)
      };
    }; // 初始化渲染的下拉列表


    _this.initOptions = function (options, value) {
      var initOptionsArray = [options];
      value.forEach(function (valueItem) {
        var result = options.filter(function (optionItem) {
          return optionItem[_this.names.value] === valueItem;
        });

        if (result.length !== 0 && result[0][_this.names.children]) {
          initOptionsArray.push(result[0][_this.names.children]);
          options = result[0][_this.names.children];
        }
      });
      return initOptionsArray;
    }; // 初始化渲染的下拉列表


    _this.initSearchOption = function (options) {
      var searchOption = {
        value: [],
        selectedOptions: [],
        label: ''
      };
      var searchOptions = [];

      if (options.length) {
        options.forEach(function (item) {
          _this.getSearchOptions(item, searchOptions, cloneLoop(searchOption));
        });
        searchOptions.forEach(function (item) {
          item.label = item.selectedOptions.map(function (option) {
            return option[_this.names.label];
          }).join('/');
        });
        return searchOptions;
      }

      return [];
    }; // 获取单列渲染的下拉列表


    _this.getSearchOptions = function (item, searchOptions, searchOption) {
      searchOption.value.push(item[_this.names.value]);
      searchOption.selectedOptions.push(item); // children 为空判断为最后一级

      if (item[_this.names.children] && item[_this.names.children].length > 0) {
        item[_this.names.children].map(function (childItem) {
          _this.getSearchOptions(childItem, searchOptions, cloneLoop(searchOption));
        });
      } else {
        searchOptions.push(searchOption);
      }
    }; // 渲染更新下一级列表


    _this.updateOptions = function (item, optionsItemIndex) {
      // 当前选中位置之后的元素都清空
      _this.state.options.splice(optionsItemIndex + 1); // 当前选中位置之后插入新的子列


      _this.state.options.push(item[_this.names.children] || []);

      _this.setState(function (state) {
        return {
          options: state.options
        };
      });
    }; // 获得临时选中的值和选项


    _this.getTempSelect = function (item, optionsItemIndex) {
      var _this$state = _this.state,
          tempValue = _this$state.tempValue,
          tempSelectedOptions = _this$state.tempSelectedOptions; // 当前选中位置之后的元素都清空

      tempValue.splice(optionsItemIndex); // 当前选中位置之后插入新的子列

      tempValue.push(item[_this.names.value]); // 当前选中位置之后的元素都清空

      tempSelectedOptions.splice(optionsItemIndex); // 当前选中位置之后插入新的子列

      tempSelectedOptions.push(item);
      return {
        tempValue: tempValue,
        tempSelectedOptions: tempSelectedOptions
      };
    }; // 开启级联panel


    _this.showDropdownPanel = function () {
      //  异步获取menu数据，展示时重新赋值
      var options = _this.initOptions(_this.props.options, _this.state.value);

      _this.setState({
        options: options,
        dropdownPanelDisplay: 'block'
      });
    }; // 隐藏级联panel


    _this.hideDropdownPanel = function () {
      // 将面板回归到上一次确定选择的结果
      var options = _this.initOptions(_this.props.options, _this.state.value);

      _this.setState({
        tempSelectedOptions: cloneLoop(_this.state.selectedOptions),
        tempValue: cloneLoop(_this.state.value),
        options: options,
        dropdownPanelDisplay: 'none'
      });
    }; // 开启筛选级联panel


    _this.showSearchPanel = function () {
      _this.setState({
        searchPanelDisplay: 'block'
      });
    }; // 隐藏筛选级联panel


    _this.hideSearchPanel = function () {
      _this.setState({
        searchPanelDisplay: 'none'
      });
    }; // 过滤筛选列表


    _this.filterSearchOptions = function (searchOptions) {
      return searchOptions.filter(function (item) {
        return item.label.indexOf(_this.state.inputValue) >= 0;
      });
    }; // 获取展示在input中文案


    _this.getDisplayText = function () {
      return _this.state.selectedOptions.map(function (item) {
        return item[_this.names.label];
      }).join('/');
    }; // 获取icon的样式


    _this.getIconClassName = function () {
      var iconClassName = 'roo-icon addon-icon ';

      if (_this.state.isMouseOver) {
        if (!_this.props.clearable || _this.state.selectedOptions.length === 0) {
          iconClassName += 'roo-icon-chevron-down';
        } else {
          iconClassName += 'roo-icon-times-circle';
        }
      } else {
        iconClassName += 'roo-icon-chevron-down';
      }

      return iconClassName;
    };

    _this.isLeaf = function (item) {
      if (item[_this.names.isLeaf]) {
        return true;
      } else {
        if (item[_this.names.isLeaf] === undefined) {
          return !item[_this.names.children] || item[_this.names.children].length === 0;
        } else {
          return false;
        }
      }
    };

    _this.getItemIcon = function (item, active) {
      if (item.loading) {
        return /*#__PURE__*/React.createElement(Icon, {
          name: "loading",
          size: 14
        });
      }

      return _this.isLeaf(item) ? null : /*#__PURE__*/React.createElement(Icon, {
        size: 14,
        name: "chevron-right"
      });
    };

    _this.handleClickOutside = function () {
      _this.hideDropdownPanel();

      _this.hideSearchPanel();
    };

    _this.handleOnSearchPanelClick = function (optionsItem) {
      var value = optionsItem.value,
          selectedOptions = optionsItem.selectedOptions;

      var options = _this.initOptions(_this.props.options, value);

      _this.setState({
        options: options,
        tempValue: cloneLoop(value),
        value: value,
        tempSelectedOptions: cloneLoop(selectedOptions),
        selectedOptions: selectedOptions,
        searchPanelDisplay: 'none'
      });

      _this.props.onChange(value, selectedOptions);
    };

    _this.handleOnItemClick = function (item, liIndex, optionsItemIndex) {
      if (!item.disabled) {
        var _this$props = _this.props,
            changeOnSelect = _this$props.changeOnSelect,
            expandTrigger = _this$props.expandTrigger;
        var _this$props2 = _this.props,
            loadData = _this$props2.loadData,
            onChange = _this$props2.onChange; // 如果存在loadData，强制expandTrigger为click,changeOnSelect为false

        if (loadData) {
          expandTrigger = 'click';
          changeOnSelect = false;
        }

        if (changeOnSelect) {
          expandTrigger = 'hover';
        }

        var isLeaf = _this.isLeaf(item);

        if (expandTrigger === 'click') {
          // 更新下级
          _this.updateOptions(item, optionsItemIndex); // 更新临时选择


          var _this$getTempSelect = _this.getTempSelect(item, optionsItemIndex),
              _tempValue = _this$getTempSelect.tempValue,
              _tempSelectedOptions = _this$getTempSelect.tempSelectedOptions;
          /***
           * 判断是否是最后一级
           * 如果是，更新临时选择、最终选择，并收起面板
           * 如果不是，更新临时选择。
           */


          if (isLeaf) {
            _this.setState({
              tempValue: _tempValue,
              value: cloneLoop(_tempValue),
              tempSelectedOptions: _tempSelectedOptions,
              selectedOptions: cloneLoop(_tempSelectedOptions),
              dropdownPanelDisplay: isLeaf ? 'none' : 'block'
            }, function () {
              onChange(_this.state.value, _this.state.selectedOptions);
            });
          } else {
            _this.setState({
              tempValue: _tempValue,
              tempSelectedOptions: _tempSelectedOptions
            }); // 非叶子节点并且，无children或者children长度为0的


            if (loadData && (!item[_this.names.children] || item[_this.names.children].length === 0)) {
              loadData(item); // this.item = item;

              _this.optionsItemIndex = optionsItemIndex;
              _this.liIndex = liIndex;
            }
          }
        } else {
          /***
           * hover触发下一级，点击操作，只会触发回调，收起面板.
           * 触发回调只有两种情况
           * 1.最后一级
           * 2.允许选择任意一级的选项
           */
          if (isLeaf || changeOnSelect) {
            // 只更新最后选择，因为临时选择，在hover的时候已经更新
            _this.setState({
              value: cloneLoop(_this.state.tempValue),
              selectedOptions: cloneLoop(_this.state.tempSelectedOptions),
              dropdownPanelDisplay: 'none'
            }, function () {
              _this.props.onChange(_this.state.value, _this.state.selectedOptions);
            });
          }
        }
      }
    };

    _this.handleOnItemMouseOver = function (item, optionsItemIndex) {
      if (!item.disabled) {
        var expandTrigger = _this.props.expandTrigger;
        var _this$props3 = _this.props,
            changeOnSelect = _this$props3.changeOnSelect,
            loadData = _this$props3.loadData;

        if (changeOnSelect) {
          expandTrigger = 'hover';
        } // click状态下，什么都不更新


        if (expandTrigger === 'hover' && !loadData) {
          _this.updateOptions(item, optionsItemIndex);

          var _this$getTempSelect2 = _this.getTempSelect(item, optionsItemIndex),
              _tempValue2 = _this$getTempSelect2.tempValue,
              _tempSelectedOptions2 = _this$getTempSelect2.tempSelectedOptions;

          _this.setState({
            tempValue: _tempValue2,
            tempSelectedOptions: _tempSelectedOptions2
          });
        }
      }
    };

    _this.handleOnInputClick = function (e) {
      if (!_this.props.disabled) {
        // 两个面板都不显示的情况下，打开下拉列表
        if (_this.state.dropdownPanelDisplay === 'none' && _this.state.searchPanelDisplay === 'none') {
          _this.showDropdownPanel();
        } else {
          _this.hideDropdownPanel();
        }
      }
    };

    _this.handleOnInputMouseOver = function () {
      if (!_this.props.disabled) {
        _this.setState({
          isMouseOver: true
        });
      }
    };

    _this.handleOnInputMouseOut = function () {
      if (!_this.props.disabled) {
        _this.setState({
          isMouseOver: false
        });
      }
    };

    _this.handleOnIconClick = function (e) {
      var options = _this.state.options; // 可清除，并且有选中

      if (_this.props.clearable && _this.state.selectedOptions.length !== 0) {
        e.stopPropagation();

        _this.setState({
          selectedOptions: [],
          tempSelectedOptions: [],
          tempValue: [],
          value: [],
          options: [options[0]],
          inputValue: ''
        }, function () {
          _this.handleClear();
        });
      }
    };

    _this.handleClear = function () {
      var onChange = _this.props.onChange;

      if (isFunction(onChange)) {
        onChange([], []);
      }
    };

    _this.handleOnInputKeyDown = function (e) {
      var options = _this.state.options;

      if (e.keyCode === 8) {
        // backspace
        if (_this.getDisplayText() !== '') {
          _this.setState({
            value: [],
            tempValue: [],
            selectedOptions: [],
            tempSelectedOptions: [],
            options: [options[0]],
            inputValue: ''
          }, function () {
            _this.handleClear();
          });
        }
      }
    };

    _this.handleOnInputChange = function (e) {
      var inputValue = e.target.value;

      _this.setState({
        inputValue: inputValue
      });

      if (_this.props.filterable) {
        if (inputValue !== '') {
          _this.hideDropdownPanel();

          _this.showSearchPanel();
        } else {
          // 输入的为空的时候,展开下拉级联列表
          _this.showDropdownPanel();

          _this.hideSearchPanel();
        }
      }
    }; // 渲染筛选级联


    _this.renderSearchOptionPanel = function (searchOptions) {
      if (_this.props.filterable) {
        return /*#__PURE__*/React.createElement("div", {
          className: "roo-dropdown-menu-cascader roo-dropdown-menu-cascader-search"
        }, /*#__PURE__*/React.createElement("ul", {
          className: "roo-dropdown-menu",
          style: {
            display: _this.state.searchPanelDisplay
          }
        }, searchOptions.length === 0 ? /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Link, {
          className: "disabled"
        }, "\u65E0\u5339\u914D\u6570\u636E")) : searchOptions.map(function (optionsItem) {
          return /*#__PURE__*/React.createElement("li", {
            key: optionsItem.label,
            onClick: _this.handleOnSearchPanelClick.bind(_assertThisInitialized(_this), optionsItem)
          }, /*#__PURE__*/React.createElement(Link, null, optionsItem.label));
        })));
      } else {
        return null;
      }
    };

    _this.renderItemLi = function (item, index, optionsItemIndex) {
      var className = '';
      var active = _this.state.tempValue[optionsItemIndex] === item[_this.names.value];

      var isLeaf = _this.isLeaf(item);

      if (item[_this.names.disabled]) {
        className = 'disabled';
      } else if (active) {
        className = 'active-highlight';
      }

      if (!isLeaf) {
        className = "".concat(className, " withoutAfter");
      }

      return /*#__PURE__*/React.createElement("li", {
        key: item[_this.names.value],
        onMouseOver: _this.handleOnItemMouseOver.bind(_assertThisInitialized(_this), item, optionsItemIndex),
        onClick: _this.handleOnItemClick.bind(_assertThisInitialized(_this), item, index, optionsItemIndex)
      }, /*#__PURE__*/React.createElement(Link, {
        className: "overflow-hidden ".concat(className)
      }, /*#__PURE__*/React.createElement("div", null, _this.optionRenderer(item)), _this.getItemIcon(item, active)));
    }; // 渲染级联列表


    _this.renderDropdownPanel = function (options) {
      return /*#__PURE__*/React.createElement("div", {
        className: "roo-dropdown-menu-cascader"
      }, options.length === 0 ? null : options.map(function (optionsItem, optionsItemIndex) {
        return optionsItem.length > 0 ? /*#__PURE__*/React.createElement("ul", {
          key: optionsItemIndex,
          className: "roo-dropdown-menu",
          style: {
            display: _this.state.dropdownPanelDisplay
          }
        }, optionsItem.map(function (item, index) {
          return _this.renderItemLi(item, index, optionsItemIndex);
        })) : null;
      }));
    };

    _this.componentWillReceiveProps = function (nextProps) {
      var value = nextProps.value;

      var _this$init = _this.init(nextProps.options, nextProps.value),
          selectedOptions = _this$init.selectedOptions,
          tempValue = _this$init.tempValue,
          tempSelectedOptions = _this$init.tempSelectedOptions;

      var searchOptions = _this.initSearchOption(nextProps.options);

      var options = _this.initOptions(nextProps.options, _this.props.loadData ? _this.state.tempValue : nextProps.value);

      if (_this.props.loadData) {
        options.splice(_this.optionsItemIndex + 1);
        var nextOptions = options[_this.optionsItemIndex] && options[_this.optionsItemIndex][_this.liIndex] && options[_this.optionsItemIndex][_this.liIndex][_this.names.children];
        options.push(nextOptions || []);
      }

      _this.setState({
        value: value,
        searchOptions: searchOptions,
        options: options,
        tempValue: _this.props.loadData ? _this.state.tempValue : tempValue,
        tempSelectedOptions: _this.props.loadData ? _this.state.tempSelectedOptions : tempSelectedOptions,
        // FIXME: temp working, need to refactor
        selectedOptions: selectedOptions
      });
    };

    _this.names = _Object$assign({
      value: 'value',
      label: 'label',
      disabled: 'disabled',
      children: 'children',
      isLeaf: 'isLeaf'
    }, _this.props.fieldNames);

    var _this$init2 = _this.init(_this.props.options, _this.props.value),
        value = _this$init2.value,
        tempValue = _this$init2.tempValue,
        selectedOptions = _this$init2.selectedOptions,
        tempSelectedOptions = _this$init2.tempSelectedOptions;

    var searchOptions = _this.initSearchOption(_this.props.options);

    var options = _this.initOptions(_this.props.options, _this.props.value);

    _this.state = {
      dropdownPanelDisplay: 'none',
      isMouseOver: false,
      options: options,
      value: value,
      tempValue: tempValue,
      selectedOptions: selectedOptions,
      tempSelectedOptions: tempSelectedOptions,
      inputValue: '',
      searchOptions: searchOptions,
      searchPanelDisplay: 'none'
    };
    _this.optionsItemIndex = 0;
    _this.liIndex = 0;

    _this.optionRenderer = _this.props.optionRenderer || function (option) {
      return option[_this.names.label];
    };

    _this.sizeMap = {
      large: 'lg',
      normal: 'md',
      small: 'sm',
      mini: 'xs'
    };
    return _this;
  }

  _createClass(Cascader, [{
    key: "render",
    value: function render() {
      var iconClassName = this.getIconClassName();
      var displayText = this.getDisplayText();
      return /*#__PURE__*/React.createElement("div", {
        className: "dropdown"
      }, /*#__PURE__*/React.createElement("div", {
        className: "roo-input-group has-icon",
        onMouseOver: this.handleOnInputMouseOver,
        onFocus: function onFocus() {
          return undefined;
        },
        onMouseOut: this.handleOnInputMouseOut,
        onBlur: function onBlur() {
          return undefined;
        }
      }, /*#__PURE__*/React.createElement("input", {
        disabled: this.props.disabled,
        type: "text",
        className: "roo-input roo-input-".concat(this.sizeMap[this.props.size || 'normal']),
        placeholder: this.props.placeholder,
        value: displayText || this.state.inputValue,
        onKeyDown: this.handleOnInputKeyDown,
        onChange: this.handleOnInputChange,
        onClick: this.handleOnInputClick
      }), this.props.disabled ? null : /*#__PURE__*/React.createElement("i", {
        className: iconClassName,
        onClick: this.handleOnIconClick
      })), this.renderDropdownPanel(this.state.options), this.renderSearchOptionPanel(this.filterSearchOptions(this.state.searchOptions)));
    }
  }]);

  return Cascader;
}(React.Component);

Cascader.propTypes = {
  value: PropTypes.array,
  options: PropTypes.array,
  placeholder: PropTypes.string,
  expandTrigger: PropTypes.string,
  changeOnSelect: PropTypes.bool,
  onChange: PropTypes.func,
  clearable: PropTypes.bool,
  disabled: PropTypes.bool,
  loadData: PropTypes.func,
  filterable: PropTypes.bool,
  size: PropTypes.string,
  fieldNames: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
    disabled: PropTypes.string,
    children: PropTypes.string,
    isLeaf: PropTypes.string
  })
};
Cascader.defaultProps = {
  value: [],
  options: [],
  placeholder: '',
  expandTrigger: 'click',
  changeOnSelect: false,
  onChange: function onChange() {},
  clearable: true,
  disabled: false,
  filterable: false,
  fieldNames: {
    value: 'value',
    label: 'label',
    disabled: 'disabled',
    children: 'children',
    isLeaf: 'isLeaf'
  },
  size: 'normal'
};
export default ClickOutside(Cascader);